// extracted by mini-css-extract-plugin
module.exports = {"field":"styles-module--field--1QY8A","footer":"styles-module--footer--1vXfh"};